import { Component, OnInit, ViewChild } from '@angular/core';
import { ChartModule } from 'angular2-chartjs';
import { RegionService } from '../../services/region/region.service';
import { Region } from '../../model/region.model';
import { MaindashboardService } from '../../services/maindashboard/maindashboard.service';
import { MatPaginator, MatTableDataSource, MatPaginatorIntl, MatSort, Sort, PageEvent } from '@angular/material';
import { Router } from '@angular/router';

import { Chart } from 'chart.js';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit {
  region = new Region();
  stateRegion = 'Select a Region';
  regions = [];
  expiration = '7';
  expireDays = [];
  approved;
  listOfRemediation: any;
  public percentage: any;
  public toFixed: any;
  public complAgentsList = [];
  public nonComplAgentsList = [];
  public pendingList = [];
  public length: any;
  public length1: any;
  public length2: any;
  public length3: any;
  public length6: any;
  public pageSize = 10;
  public pageSize1 = 10;
  public ispaginationFlag: boolean = false;
  public ispaginationFlag1: boolean = false;
  public ispaginationFlag2: boolean = false;
  public ispaginationFlag3: boolean = false;
  public ispaginationFlag6: boolean = false;
  public totalPages: number;
  public totalPages1: number;
  public totalPages2: number;
  public totalPages3: number;
  public totalPages6: number;
  matSpinner: boolean = false;
  public noResultsFound: any;
  public noResults: any;
  public noResults1: any;
  public noResults2: any;
  public errMsg: any;
  public typeErr: boolean = false;
  public typeErr1: boolean = false;
  public role: string;
  public regionSelected: any;
  public selectedTabIndex: any;
  public platinumValue: string = 'Y';
  public innerStrokeColor = '#C7E596';
  public outerStrokeColor = '#78C000';
  pageEvent: PageEvent;

  displayedColumns = ['MasterVendorName', 'DocumentTypeName', 'ExpirationDate'];
  displayedColumns1 = ['MasterVendorName1', 'DocumentTypeName1', 'ExpirationDate1', 'DocumentStatus'];
  displayedColumns2 = ['MasterVendorName1', 'EmployeeName', 'EmployeeRole', 'DocumentStatus'];
  displayedColumns3 = ['Region', 'PA', 'IP', 'REJ', 'ED'];
  displayedColumns4 = ['Region', 'Count'];
  displayedColumns5 = ['MasterVendorName', 'LocationId', 'Remediation'];

  dataSource = new MatTableDataSource<VendorCompliance>();
  dataSource1 = new MatTableDataSource<VendorCompliance>();
  dataSource2 = new MatTableDataSource<UserData>();
  dataSource3 = new MatTableDataSource<PendingData>();
  dataSource4 = new MatTableDataSource<any>();
  dataSource5 = new MatTableDataSource<remediationCount>();
  dataSource6 = new MatTableDataSource<remediationListNum>();

  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild('paginator1') paginator1: MatPaginator;
  @ViewChild('paginator2') paginator2: MatPaginator;
  @ViewChild('paginator3') paginator3: MatPaginator;
  @ViewChild('paginator6') paginator6: MatPaginator;
  @ViewChild('matSort1') matSort1: MatSort;
  @ViewChild('matSort2') matSort2: MatSort;
  @ViewChild('matSort3') matSort3: MatSort;
  @ViewChild('matSort4') matSort4: MatSort;
  @ViewChild('matSort5') matSort5: MatSort;
  sortedData: any;
  public statusTable: boolean = false;
  public remediationTable: boolean = false;
  public complainceChart: boolean= true;
  approveCount: any;
  rejectCount: any;
  inProgressCount: any;
  pendingApprovalCount: any;
  pendingRequestCount: any;
  docStatusData: any[];
  docStatusTableData = [];
  employeeDeleteData = [];
  showEmployeeTable: boolean = false;
  requestList =[];
  countPerRegion: any;
 
  constructor(public regionService: RegionService,
              public mainDashService: MaindashboardService,
              private router: Router) {
    this.expireDays = ["14", "30"];
  }

  ngOnInit() {
    this.regionService.regionGet(this.region).subscribe(res => {
      this.regions = [];
      this.typeErr = false;
      this.typeErr1 = false;

      if (res !== undefined && res !== '') {
        if (res.Regions !== undefined && res.Regions.length > 0) {
          res.Regions.forEach(data => {
            this.regions.push(data.region);
          });
        } else {
          this.errMsg = "No Regions data found ";
          this.typeErr1 = true;
        }
      } else {
        this.errMsg = "No Regions data found ";
        this.typeErr1 = true;
      }
    }, err => {
      this.errMsg = "Regions Service " + err;
      this.typeErr = true;
    });

    this.regionChange('All', this.expiration);
    // API Call to get the docs from all the statuses
    this.mainDashService.getPendingApprovalsList('Pending Approval,Approved,In Progress,Rejected').subscribe(res => {
      this.mainDashService.getPendingRequestList('Pending Request').subscribe(res2 => {
        this.docStatusData = res.VendorDocs;
        if (res2.EmployeeInfo.length > 0) {
          this.employeeDeleteData = res2.EmployeeInfo;
          this.docStatusData = this.docStatusData.concat(this.employeeDeleteData);
        }
        this.getdocStatusData();
      }, err => {
      });
    }, err => {
    });
  }
  remediationListBasedCount(id){
    this.mainDashService.getListOfRemediations(id).subscribe(res=>{
      this.remediationDetails(res);
    })
  }
  remediationList(){
    this.mainDashService.getRemediationList().subscribe(res=>{
    this.remediationDetails(res);
    });
  }
  remediationDetails(res){
    this.dataSource6 = null;
    if(res.Status === 200 && res.Locations.length > 0){
      this.listOfRemediation = res.Locations;
      this.noResultsFound = '';
      this.dataSource6 = new MatTableDataSource<remediationListNum>(this.listOfRemediation);
      this.dataSource6.sort = this.matSort5;
      this.length6 = this.listOfRemediation.length;
      this.totalPages6 = Math.ceil(this.length6 / 10);
      if (this.length6 <= 10) {
        this.ispaginationFlag6 = false;
        this.paginator6.pageIndex = 0;
      } else {
        this.ispaginationFlag6 = true;
      }  
      if (this.paginator6.pageIndex >= this.totalPages6) {
        this.paginator6.pageIndex = this.totalPages6 - 1;
      }
      this.dataSource6.paginator = this.paginator6;
      this.dataSource6.paginator._intl = this.setPaginator(this.length6);
    } else if(res.Locations.length === 0){
      this.noResultsFound = "No Locations found";
      this.length6 = res.Locations.length;
      if (this.length6 <= 10) {
        this.ispaginationFlag6 = false;
        this.paginator6.pageIndex = 0;
      } else {
        this.ispaginationFlag6 = true;
      }
      this.dataSource6.paginator = this.paginator6;
    }
  }
  remediationsCount(){
    this.mainDashService.getRemediationCount().subscribe(res=>{
      if(res.Status === 200 && res.RemediationCount.length > 0){
          this.countPerRegion = res.RemediationCount;
          this.dataSource5 = new MatTableDataSource(this.countPerRegion);
      }
    })
  }
  regionChange(region, days) {
    
    if (region == "Select a Region") {
      region = 'All';
    }
    this.regionSelected = region;
    if (this.selectedTabIndex === undefined || this.selectedTabIndex === 0) {
      this.platinumValue = 'Y';
    } else if (this.selectedTabIndex === 1) {
      this.platinumValue = 'N';
    }
    this.matSpinner = true;
    if (region === 'All') {
      this.mainDashService.getCompliantAgentsByRegionId('All', this.platinumValue, days).subscribe(res => {
        this.matSpinner = false;
        if (this.platinumValue === 'Y')
          this.checkAgentsCompl(res);
        else (this.platinumValue === 'N')
        this.checkAgentNonCmpl(res);
        this.typeErr = false;
        this.typeErr1 = false;
      }, err => {
        this.errMsg = "Vendors Compliant Service " + err;
        this.typeErr = true;
      });
    } else {
      this.mainDashService.getCompliantAgentsByRegionId(region, this.platinumValue, days).subscribe(res => {
        this.matSpinner = false;
        if (this.platinumValue === 'Y')
          this.checkAgentsCompl(res);
        else (this.platinumValue === 'N')
        this.checkAgentNonCmpl(res);
        this.typeErr = false;
        this.typeErr1 = false;
      }, err => {
        this.errMsg = "Vendors Compliant by RegionId Service " + err;
        this.typeErr = true;
      });
    }
  }

  checkAgentsCompl(res) {
    this.complAgentsList = [];
    if (res.PlatinumPercentWithRound <= 0) {
      this.percentage = res.PlatinumPercent;
      this.toFixed = 2;
    } else {
      this.percentage = res.PlatinumPercentWithRound;
      this.toFixed = 0;
    }
    /*** Checking for Compliant Vendors ***/
    if (res.VendorDocs !== undefined && res.VendorDocs.length > 0) {
      for (let i = 0; i < res.VendorDocs.length; i++) {
        res.VendorDocs[i].MasterVendorName = res.VendorDocs[i].MasterVendorName;
        res.VendorDocs[i].DocumentTypeName = res.VendorDocs[i].DocumentTypeName;
        res.VendorDocs[i].ExpirationDate = res.VendorDocs[i].ExpirationDate;

        this.complAgentsList.push(res.VendorDocs[i]);
      }
      this.noResults = '';
      this.dataSource = new MatTableDataSource<VendorCompliance>(this.complAgentsList);
      this.dataSource.sort = this.matSort1;
      this.length = this.complAgentsList.length;
      this.totalPages = Math.ceil(this.length / 10);
      if (this.length <= 10) {
        this.ispaginationFlag = false;
        this.paginator.pageIndex = 0;
      } else {
        this.ispaginationFlag = true;  
      }
      if (this.paginator.pageIndex >= this.totalPages) {
        this.paginator.pageIndex = this.totalPages - 1;
      }
      this.dataSource.paginator = this.paginator;
      this.dataSource.paginator._intl = this.setPaginator(this.length);
    } else {
      this.complAgentsList = [];
      this.noResults = 'No documents expiring within ' + this.expiration + ' days.';
      this.dataSource = new MatTableDataSource<VendorCompliance>(this.complAgentsList);
      this.length = this.complAgentsList.length;
      if (this.length <= 10) {
        this.ispaginationFlag = false;
        this.paginator.pageIndex = 0;
      } else {
        this.ispaginationFlag = true;
      }
      this.dataSource.paginator = this.paginator;
      // this.percentage = 0;
      // this.toFixed = 0;
    }
  }

  checkAgentNonCmpl(res) {
    this.nonComplAgentsList = [];
    /*** Checking for Non-Compliant Vendors ***/
    if (res.VendorDocs !== undefined && res.VendorDocs.length > 0) {
      for (let i = 0; i < res.VendorDocs.length; i++) {
        res.VendorDocs[i].MasterVendorName = res.VendorDocs[i].MasterVendorName;
        res.VendorDocs[i].DocumentTypeName = res.VendorDocs[i].DocumentTypeName;
        res.VendorDocs[i].ExpirationDate = res.VendorDocs[i].ExpirationDate;

        this.nonComplAgentsList.push(res.VendorDocs[i]);
      }
      this.noResults1 = '';
      this.dataSource1 = new MatTableDataSource<VendorCompliance>(this.nonComplAgentsList);
      this.dataSource1.sort = this.matSort2;
      this.length1 = this.nonComplAgentsList.length;
      this.totalPages1 = Math.ceil(this.length1 / 10);
      if (this.length1 <= 10) {
        this.ispaginationFlag1 = false;
        this.paginator1.pageIndex = 0;
      } else {
        this.ispaginationFlag1 = true;
      }
      if (this.paginator1.pageIndex >= this.totalPages1) {
        this.paginator1.pageIndex = this.totalPages1 - 1;
      }
      this.dataSource1.paginator = this.paginator1;
      this.dataSource1.paginator._intl = this.setPaginator(this.length1);
    } else {
      this.nonComplAgentsList = [];
      this.noResults1 = 'No documents expiring within ' + this.expiration + ' days.';
      this.dataSource1 = new MatTableDataSource<VendorCompliance>(this.nonComplAgentsList);
      this.length1 = this.nonComplAgentsList.length;
      if (this.length1 <= 10) {
        this.ispaginationFlag1 = false;
        this.paginator1.pageIndex = 0;
      } else {
        this.ispaginationFlag1 = true;
      }
      this.dataSource1.paginator = this.paginator1;
    }
  }

  pendingApprovalsList(res) {
    /*   if(this.callContext) {
         let ctx = document.getElementById("canvas");
         this.chart = new Chart(ctx, {
           //showTooltips: false,
           type: 'horizontalBar',
           data: {
             labels: ["Approved", "In Progress", "Rejected", "Pending Approval"],
             datasets: [{
               label: '# ofDocs',
               data: this.ChartData,
               backgroundColor: [
                 'limegreen',
                 'rgb(66, 140, 244)',
                 'rgb(244, 65, 65)',
                 'rgb(183, 179, 179)',
               ]/!*,
             borderColor: [
               'rgba(255,99,132,1)',
               'rgba(54, 162, 235, 1)',
               'rgba(255, 206, 86, 1)',
               'rgba(75, 192, 192, 1)',
             ],
             borderWidth: 1*!/
             }]
           },
           options: {
             legend: {
               display: false,
               onHover: function(e) {
                 e.target.style.cursor = 'pointer';
               }
             },
             scales: {
               xAxes: [{
                 display: true,
                 ticks: {
                   beginAtZero: true,
                   fontColor: 'black',
                   fontFamily:  'Montserrat',
                   fontSize: 14
                 }
               }],
               yAxes: [{
                 display: true,
                 ticks: {
                   fontColor: 'black',
                   fontFamily:  'Montserrat',
                   fontSize: 14
                 }
               }],
             },
             'onClick': (e, array) => this.refreshStatusOnCLick(e, array),
             responsive: false,
             //events: false,
             tooltips: {
               enabled: true,
               fontFamily: 'Montserrat',
               backgroundColor: 'black',
               titleFontFamily: 'Montserrat',
               titleFontColor: 'white',
               bodyFontColor: 'white'
             },
             hover: {
               animationDuration: 0,
               onHover: function(e) {
                 let point = this.getElementAtEvent(e);
                 if (point.length) e.target.style.cursor = 'pointer';
                 else e.target.style.cursor = 'default';
               }
             },
             animation: {
               duration: 0,
               onComplete: function () {
                 let chartInstance = this.chart,
                   ctx = chartInstance.ctx;
                 ctx.font = Chart.helpers.fontString(14, 'bold', 'Montserrat','black');
                 ctx.textAlign = 'center';
                 ctx.textBaseline = 'bottom';
                 ctx.fillStyle = 'black';

                 this.data.datasets.forEach(function (dataset, i) {
                   let meta = chartInstance.controller.getDatasetMeta(i);
                   meta.data.forEach(function (bar, index) {
                     let data = dataset.data[index];
                     ctx.fillText(data, bar._model.x +15, bar._model.y+10);
                   });
                 });
               }
             }
           }
         });
       }*/
   
    this.pendingList = [];
    if (res.VendorDocs !== undefined && res.VendorDocs.length > 0) {
      for (let i = 0; i < res.VendorDocs.length; i++) {
        res.VendorDocs[i].MasterVendorName1 = res.VendorDocs[i].MasterVendorName;
        res.VendorDocs[i].DocumentTypeName1 = res.VendorDocs[i].DocumentTypeName;
        res.VendorDocs[i].ExpirationDate1 = res.VendorDocs[i].ExpirationDate;
        res.VendorDocs[i].DocumentStatus = res.VendorDocs[i].DocumentStatus;
        this.pendingList.push(res.VendorDocs[i]);
      }
     
      this.noResults2 = '';
      this.dataSource2 = new MatTableDataSource<UserData>(this.pendingList);

      this.dataSource2.sort = this.matSort3;
      this.length2 = this.pendingList.length;
      this.totalPages2 = Math.ceil(this.length2 / 10);
      if (this.length2 <= 10) {
        this.ispaginationFlag2 = false;
        this.paginator2.pageIndex = 0;
      } else {
        this.ispaginationFlag2 = true;
      }
      if (this.paginator2.pageIndex >= this.totalPages2) {
        this.paginator2.pageIndex = this.totalPages2 - 1;
      }
      this.dataSource2.paginator = this.paginator2;
      this.dataSource2.paginator._intl = this.setPaginator(this.length2);
    } else {
      this.pendingList = [];
      this.noResults2 = 'No documents found';
      this.dataSource2 = new MatTableDataSource<UserData>(this.pendingList);
      this.length2 = this.pendingList.length;
      if (this.length2 <= 10) {
        this.ispaginationFlag2 = false;
        this.paginator2.pageIndex = 0;
      } else {
        this.ispaginationFlag2 = true;
      }
      this.dataSource2.paginator = this.paginator2;
    }
  }

  setPaginator(len) {
    const paginatorIntl = new MatPaginatorIntl();
    paginatorIntl.itemsPerPageLabel = 'Items per page';
    paginatorIntl.nextPageLabel = 'Next page';
    paginatorIntl.previousPageLabel = 'Previous page';
    paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      length = len;
      if (length == 0 || pageSize == 0) {
        return `0 van ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      // If the start index exceeds the list length, do not try and fix the end index to the end.
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      const round = Math.ceil(length / 10)
      return `${(startIndex / 10) + 1}  of ${round}`;
    }
    return paginatorIntl;
  }

  getColor(expirationDate) {
    let todayDate = new Date()
    let currentDate = new Date().setHours(0, 0, 0, 0);
    var targetDate = new Date();
    let futureDate = targetDate.setDate(todayDate.getDate() + 30);
    let future = new Date(futureDate).setHours(0, 0, 0, 0);
    let expDate = new Date(expirationDate).setHours(0, 0, 0, 0);
    if (expDate < currentDate) {
      return "red";
    }
    else if (expDate > future) {
      return "black";
    }
    else {
      return "blue";
    }
  }

  getStatusColor(documentStatus) {
    if (documentStatus == 'PendingApproval') {
      return "black";
    } else if (documentStatus == 'Approved') {
      return "green";
    } else if (documentStatus == 'InProgress') {
      return "blue";
    } else {
      return "red";
    }
  }

  selectedVendor(agentId) {
    if (agentId !== undefined && agentId !== null) {
      localStorage.setItem("AgentId", agentId);
      this.router.navigate(['agent/dashboard', agentId, 'Dashboard']);
    }
  }

  selectedLocation(element){
    this.router.navigate(['agent/location', element.MasterVendorId, 'LocationSummary', element.LocationId]);
  }

  selectDoc(data) {
    localStorage.setItem("AgentId", data.MasterVendorId);
    localStorage.setItem("AgentName", data.MasterVendorName)
    localStorage.setItem('EmployeeId', data.EmployeeId);
    localStorage.setItem('dbId', data.DocId !== undefined ? data.DocId : '');
    localStorage.setItem("LocationId", data.LocationId);
    if (data.MasterVendorId !== undefined && data.MasterVendorId !== null && data.Category === 'DUEDILIGENCE') {
      this.router.navigate(['agent/duediligence', data.MasterVendorId, 'DUEDILIGENCE']);
    } else if (data.MasterVendorId !== undefined && data.MasterVendorId !== null && data.Category === 'INSURANCE') {
      this.router.navigate(['agent/insurance', data.MasterVendorId, 'INSURANCE']);
    } else if (data.MasterVendorId !== undefined && data.MasterVendorId !== null && data.Category === 'EMPLOYEE' && data.EmployeeId !== undefined && data.EmployeeId !== null) {
      this.router.navigate(['agent/agentemployee', data.MasterVendorId, 'Documents', data.EmployeeId]);
    } else if (data.MasterVendorId !== undefined && data.MasterVendorId !== null && data.Category === 'LOCATION' && data.LocationId !== undefined && data.LocationId !== null) {
      this.router.navigate(['agent/location', data.MasterVendorId, 'Documents', data.LocationId]);
    } else if (data.MasterVendorId !== undefined && data.MasterVendorId !== null && data.Category === 'LICENSE') {
      this.router.navigate(['agent/license', data.MasterVendorId, 'LICENSE']);
    } else if (data.MasterVendorId !== undefined && data.MasterVendorId !== null && data.Category === 'SUMMARY') {
      this.router.navigate(['agent/summary', data.MasterVendorId, 'SUMMARY']);
    }
  }

  tabClick(tab) {
    this.selectedTabIndex = tab.index;
    this.matSpinner = true;
    if (tab.index === 0) {
      this.statusTable = false;
      this.complainceChart = true;
      this.remediationTable = false;
      this.mainDashService.getCompliantAgentsByRegionId(this.regionSelected, 'Y', this.expiration).subscribe(res => {
        this.matSpinner = false;
        this.checkAgentsCompl(res);
        this.typeErr = false;
        this.typeErr1 = false;
      }, err => {
        this.errMsg = "Vendors Compliant Service " + err;
        this.typeErr = true;
      });
    } else if (tab.index === 1) {
      this.statusTable = false;
      this.remediationTable = false;
      this.complainceChart = true;
      this.mainDashService.getCompliantAgentsByRegionId(this.regionSelected, 'N', this.expiration).subscribe(res => {
        this.matSpinner = false;
        this.checkAgentNonCmpl(res);
        this.typeErr = false;
        this.typeErr1 = false;
      }, err => {
        this.errMsg = "Vendors Compliant Service " + err;
        this.typeErr = true;
      });
    } else if (tab.index === 2) {
      this.statusTable = true;
      this.complainceChart = false;
      this.remediationTable = false;
      this.mainDashService.getPendingApprovalsList('Pending Approval').subscribe(res => {
        this.matSpinner = false;
        this.pendingApprovalsList(res);
        this.typeErr = false;
        this.typeErr1 = false;
      }, err => {
        this.errMsg = "Pending Approvals Service " + err;
        this.typeErr = true;
      });
    } else if(tab.index === 3){
      this.remediationTable = true;
      this.complainceChart = false;
      this.statusTable = false;
      this.remediationList();
      this.remediationsCount();
    }
  }

  /*  refreshStatusOnCLick(e, array) {
      this.callContext = false;
      let selectedIndex = array[0]._index;
      let labels= ["Approved", "In Progress", "Rejected", "Pending Approval"];
      this.mainDashService.getPendingApprovalsList(labels[selectedIndex]).subscribe(res => {
        this.matSpinner = false;
        this.pendingApprovalsList(res);
        this.typeErr = false;
        this.typeErr1 = false;
      }, err => {
        this.errMsg = "Pending Approvals Service " + err;
        this.typeErr = true;
      });
      /!*  this.mainDashService.getPendingApprovalsList(event).subscribe(res => {
          this.matSpinner = false;
          this.pendingApprovalsList(res);
          this.typeErr = false;
          this.typeErr1 = false;
        }, err => {
          this.errMsg = "Status Service " + err;
          this.typeErr = true;
        });*!/

    }*/

  getRegionStatus(region, status) {
    let region_data;
    if (status === 'Pending Request') {
      this.showEmployeeTable = true;
      region_data = this.employeeDeleteData.filter(data => (data.RegionId === region && data.EmployeeStatus === status));
      this.matSpinner = false;
      this.getPendingRequestData({
        EmployeeInfo: region_data
      });
      this.typeErr = false;
      this.typeErr1 = false;
    } else {
      this.showEmployeeTable = false;
      region_data = this.docStatusData.filter(data => (data.RegionId === region && data.DocumentStatus === status));
      this.matSpinner = false;
      this.pendingApprovalsList({
        VendorDocs: region_data
      });
      this.typeErr = false;
      this.typeErr1 = false;
    }
  }

  getdocStatusData() {
    //Logic to get the count from each region
    this.docStatusTableData = [];
    let region_array = [], region_count =0;
    this.regions.forEach(region => {
      region_count ++;
      this.approveCount = 0, this.rejectCount = 0, this.inProgressCount = 0, this.pendingApprovalCount = 0, this.pendingRequestCount = 0;
      if (region_array.indexOf(region) === -1) {
        region_array.push(region);
        let docsstatus = this.docStatusData.filter(doc => doc.RegionId === region);
        let count = 0;
        docsstatus.forEach(doc => {
          if (doc.DocumentStatus && doc.DocumentStatus.toLowerCase() === 'approved') {
            this.approveCount++;
          } else if (doc.DocumentStatus && doc.DocumentStatus.toLowerCase() === 'rejected') {
            this.rejectCount++;
          } else if (doc.DocumentStatus && doc.DocumentStatus.toLowerCase().replace(' ', '') === 'pendingapproval') {
            this.pendingApprovalCount++;
          } else if (doc.DocumentStatus && doc.DocumentStatus.toLowerCase().replace(' ', '') === 'inprogress') {
            this.inProgressCount++;
          } else if (doc.EmployeeStatus && doc.EmployeeStatus.toLowerCase().replace(' ', '') === 'pendingrequest') {
            this.pendingRequestCount++;
          }
          count++;
        });
        if (count === docsstatus.length) {
          this.docStatusTableData.push({
            'Region': region,
            'Approved': this.approveCount,
            'Reject': this.rejectCount,
            'PA': this.pendingApprovalCount,
            'In_Prog': this.inProgressCount,
            'PR': this.pendingRequestCount
          });
        }
      }
    });
    if(region_count === this.regions.length){
      this.dataSource4 = new MatTableDataSource(this.docStatusTableData);
    }
  }

  /*    getPendingRequest(event) {
        this.isPendingRequest = true;
        this.isPendingStatus = false;
        this.mainDashService.getPendingRequestList(event).subscribe(res => {
          this.matSpinner = false;
          this.getPendingRequestData(res);
          this.typeErr = false;
          this.typeErr1 = false;
        }, err => {
          this.errMsg = "Status Service " + err;
          this.typeErr = true;
        });
      }*/

  getPendingRequestData(res) {
    this.requestList = [];
    if (res.EmployeeInfo !== undefined && res.EmployeeInfo.length > 0) {
      for (let i = 0; i < res.EmployeeInfo.length; i++) {
        res.EmployeeInfo[i].MasterVendorName1 = res.EmployeeInfo[i].MasterVendorName;
        res.EmployeeInfo[i].EmployeeName = res.EmployeeInfo[i].FirstName + ' ' + res.EmployeeInfo[i].LastName;
        res.EmployeeInfo[i].EmployeeRole = res.EmployeeInfo[i].EmployeeType;
        res.EmployeeInfo[i].DocumentStatus = res.EmployeeInfo[i].EmployeeStatus;
        this.requestList.push(res.EmployeeInfo[i]);

      }

      this.noResults2 = '';
      this.dataSource3 = new MatTableDataSource<PendingData>(this.requestList);
      this.dataSource3.sort = this.matSort4;
      this.length3 = this.requestList.length;
      this.totalPages3 = Math.ceil(this.length3 / 10);
      if (this.length3 <= 10) {
        this.ispaginationFlag3 = false;
        this.paginator3.pageIndex = 0;
      } else {
        this.ispaginationFlag3 = true;
      }
      if (this.paginator3.pageIndex >= this.totalPages3) {
        this.paginator3.pageIndex = this.totalPages3 - 1;
      }
      this.dataSource3.paginator = this.paginator3;
      this.dataSource3.paginator._intl = this.setPaginator(this.length3);
    } else {
      this.requestList = [];
      this.noResults2 = 'No Employees Found';
      this.dataSource3 = new MatTableDataSource<PendingData>(this.requestList);
      this.length3 = this.requestList.length;
      if (this.length3 <= 10) {
        this.ispaginationFlag3 = false;
        this.paginator3.pageIndex = 0;
      } else {
        this.ispaginationFlag3 = true;
      }
      this.dataSource3.paginator = this.paginator3;
    }
  }
  selectEmployee(agentId) {
    if (agentId !== undefined && agentId !== null) {
      localStorage.setItem("AgentId", agentId);
      this.router.navigate(['agent/agentemployee', agentId, 'AGENTEMPLOYEE']);
    }
  }
}

export interface VendorCompliance {
  MasterVendorName: String;
  DocumentTypeName: String;
  ExpirationDate: Date;
}
export interface UserData {
  MasterVendorName: String;
  DocumentTypeName: String;
  ExpirationDate: Date;
  DocumentStatus: String;
}
export interface PendingData {
  MasterVendorName: String;
  EmployeeName: String;
  EmployeeRole: String;
  DocumentStatus: String;
}

export interface statusCount {
  Region: number;
  PA: number;
  IP: number;
  REJ: number;
  ED: number;
}

export interface remediationListNum{
LocationId: number,
MasterVendorName: String,
Remediation: String
}
export interface remediationCount{
  Region: number;
  Count:number;
}
/*

export class AppComponent {
  width = 600;
  height = 400;
  type = 'bar2d';
  dataFormat = 'json';
  dataSource = data;
}
*/



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.component.ts